'use strict';

require('mdn-polyfills/Object.values');
require('mdn-polyfills/Array.prototype.find');
require('mdn-polyfills/Array.prototype.findIndex');
require('mdn-polyfills/String.prototype.padStart');
